import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    ContactMainType,
} from 'app/enums/label.enums'
import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'

type ContactTable = Contact & {
    locationLocationName: string,
    locationCompanyCompanyName: string
}

const config: SkyNetTableConfig<keyof ContactTable> = {
    name: 'ContactsTable',
    fields: [
        {
            name: 'contactName',
            filterField: 'contactName',
            reduced: true,
            labelKey: 'NAME_AND_SURNAME',
        },
        {
            name: 'email',
            filterField: 'email',
            labelKey: 'E_MAIL',
        },
        {
            name: 'phone',
            filterField: 'phone',
            labelKey: 'PHONE',
        },
        {
            name: 'isMainContact',
            componentName: 'ChipCheckMark',
            isHidden: true,
            labelKey: 'IS_MAIN_CONTACT',
        },
        {
            name: 'locationLocationName',
            filterField: 'locationLocationName',
            labelKey: 'LOCATION',
            isHidden: true,
        },
        {
            name: 'locationCompanyCompanyName',
            filterField: 'locationCompanyCompanyName',
            reduced: true,
            labelKey: 'COMPANY',
        },
        {
            name: 'mainType',
            componentName: 'EnumList',
            allowedValuesEnum: ContactMainType,
            isHidden: true,
            labelKey: 'TYPE',
        },
        {
            name: 'createdBy',
            filterField: 'createdBy',
            isHidden: true,
            labelKey: 'CREATED_BY',
        },
    ],
}

export default config
